import React from 'react';
import { useSelector } from 'react-redux';

import { MangoolsNavBar } from 'mangools-react-components/src';
import { LinkRefSources } from 'mangools-commons/dist/constants/LinkRefSources';
import DOMService from 'mangools-commons/dist/services/DOMService';

import Preloader from 'components/reusable/Preloader';
import mnglsImageWhite from 'images/mangools-logo-full-white.svg';
import Strings from 'constants/Strings';
import { DarkModeToggle } from 'mangools-react-components/src';

import { colorSchemeSelector } from 'selectors/uiSelectors';

import { APP_CONFIG } from 'mangools-commons/dist/configs/app'

function FullAppPreloader() {
    const colorScheme = useSelector(state => colorSchemeSelector(state));

    return (
        <>
            <header className="mg-header">
                <MangoolsNavBar
                    appName={LinkRefSources.SERPCHECKER_APP}
                    rightEl={(
                        <div className="uk-flex uk-flex-middle mg-margin-r-30" style={{ opacity: 0.2 }}>
                            <div className="uk-flex uk-flex-middle">
                                {DOMService.isMobile() && (
                                    <ul className="mg-nav uk-visible-small">
                                        <li>
                                            <DarkModeToggle />
                                        </li>
                                    </ul>
                                )}
                                <div className="mg-preloader-block mg-margin-l-15" style={{ width: '30px' }} />
                            </div>
                        </div>
                    )}
                    onShowAppPanel={() => null}
                    logoDarkSrc={mnglsImageWhite}
                    logoLightSrc={mnglsImageWhite}
                    env={APP_CONFIG.APP_ENV}
                />
                <div className="mg-header-app uk-flex uk-flex-middle uk-flex-space-between uk-hidden-small">
                    <div className="uk-flex" style={{ opacity: 0.2 }}>
                        <div className="mg-padding-0-15">
                            <div className="mg-preloader-block" style={{ width: '60px' }} />
                        </div>
                        <div className="mg-padding-0-15">
                            <div className="mg-preloader-block" style={{ width: '60px' }} />
                        </div>
                    </div>
                    <div className="uk-flex" style={{ opacity: 0.2 }}>
                        <div className="mg-padding-0-15">
                            <div className="mg-preloader-block" style={{ width: '20px' }} />
                        </div>
                        <div className="mg-padding-0-15">
                            <div className="mg-preloader-block" style={{ width: '20px' }} />
                        </div>
                        <div className="mg-padding-0-15">
                            <div className="mg-preloader-block" style={{ width: '30px' }} />
                        </div>
                    </div>
                </div>
            </header>
            <div className="uk-position-cover uk-flex uk-flex-middle uk-flex-center">
                <Preloader colorScheme={colorScheme} text={Strings.components.common.loading} />
            </div>
        </>
    );
}

export default FullAppPreloader;
